// extracted by mini-css-extract-plugin
export default {"accountBreadcrumbs":"Jm-z","hideOnMobile":"Km-z"};